
import apiClient from "../core/apiClient";
import { CreatePublicAction, PublicAction } from "../interfaces/DTO/PublicAction";
import { BaseService } from "./BaseService";


const PUBLIC_API_URL = "/external-link-token";

class PublicActionService extends BaseService<PublicAction> {
  constructor() {
    super(PUBLIC_API_URL);
  }
  async createToken(dto: CreatePublicAction): Promise<PublicAction> {
    const response = await apiClient.post(`${this.baseUrl}/create-token`, dto);
    return response.data;
  }
  async getByContactId(contactId: number): Promise<PublicAction[]> {
      if (!contactId) return [];
      const response = await apiClient.get<PublicAction[]>(`${this.baseUrl}/contact/${contactId}`);
      return response.data;
    }

  async sendLinkToEmail(actionId: number): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post(`${this.baseUrl}/send-link-email/${actionId}`);
    return response.data;
  }

}

export const publicActionService = new PublicActionService();
